import FormatClearIcon from '@mui/icons-material/FormatClear';
import RttIcon from '@mui/icons-material/Rtt';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useTranslationKeyMode } from '../../hooks/useTranslationKeyMode';
import useUser from '../../hooks/useUser';

const KeyModeButton = () => {
  useTranslation(); // This will re-render button when mode changes.
  const { isTranslationKeyModeEnabled, setTranslationKeyModeEnabled } = useTranslationKeyMode();

  return (
    <Button
      variant="contained"
      className="i18n-keymode-button"
      size="small"
      color={isTranslationKeyModeEnabled ? 'secondary' : 'error'}
      onClick={() => {
        setTranslationKeyModeEnabled(!isTranslationKeyModeEnabled);
      }}
      title={isTranslationKeyModeEnabled ? 'Translations key mode enabled' : 'Translations key mode disabled'}
    >
      {isTranslationKeyModeEnabled ? <RttIcon /> : <FormatClearIcon />}
    </Button>
  );
};

export const I18nKeyModeButton = () => {
  const { user } = useUser();
  const { isTranslationKeyModeVisible } = useTranslationKeyMode();

  if (!user?.isAdmin || !isTranslationKeyModeVisible) {
    return null;
  }

  return <KeyModeButton />;
};
